<template>
  <div class="p-4 bg-white rounded-lg h-100" v-if="isDataLoaded">
    <DataTable
      :table_state="table_state"
      :store_names="store_names"
      :editComponent="componentForEditing"
      :delete_url="delete_url"
      :urls="urls"
      :bulkRemoveOption="false"
    >
      <template
        #actionsButton="{ selectedItems, refresher, pageLoader, permissions }"
      >
        <div
          class="mr-md-2 mr-sm-1 mb-1 mr-0 pa-0"
          :class="{ 'col-6 px-8 mt-3': $vuetify.breakpoint.xsOnly }"
          v-if="permissions('view')"
        >
          <button @click.prevent="regenerate" class="btn btn--export-filter">
            <span class="svg-icon">
              <v-icon size="18">mdi-refresh</v-icon>
            </span>

            <span> Regenerate </span>
          </button>
        </div>
        <Regenerate
          ref="regenerate"
          :updateTableContent="refresher"
          :pageLoader="pageLoader"
        />
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from "@/own/components/DataTable.vue";
// import EditCarrierMessage from "@/own/components/datahub/carrierMessages/EditCarrierMessage";
import {
  EXPORT_TABLE_DATA,
  SET_TABLE_FILTER,
  SET_TABLE_PAGE,
  SET_TABLE_PERPAGE,
  SET_TABLE_SORTBY,
  UPDATE_TABLE_DATA,
  UPDATE_TABLE_STRUCTURE,
} from "@/core/services/store/billingDailyStatistics.module";
import { SET_PAGE_LOADING } from "@/core/services/store/config.module";
import Regenerate from "@/own/components/finance/billingDailyStatistics/Regenerate.vue";
export default {
  name: "BillingDailyStatistics",
  components: { DataTable, Regenerate },
  data: () => ({
    componentForEditing: null,
    delete_url: `${process.env.VUE_APP_BASE_URL}/datahub/carrierMessages/destroy`,
    table_state: {
      UPDATE_TABLE_STRUCTURE: UPDATE_TABLE_STRUCTURE,
      UPDATE_TABLE_DATA: UPDATE_TABLE_DATA,
      SET_TABLE_SORTBY: SET_TABLE_SORTBY,
      SET_TABLE_FILTER: SET_TABLE_FILTER,
      SET_TABLE_PERPAGE: SET_TABLE_PERPAGE,
      SET_TABLE_PAGE: SET_TABLE_PAGE,
      EXPORT_TABLE_DATA: EXPORT_TABLE_DATA,
    },
    store_names: {
      getTableFilters: "getBILLINGDAILYSTATSTableFilters",
      getTableState: "getBILLINGDAILYSTATSTableState",
      getTableData: "getBILLINGDAILYSTATSTableData",
      getTableHeaders: "getBILLINGDAILYSTATSTableHeaders",
      getTableProperties: "getBILLINGDAILYSTATSTableProperties",
      getTableExportUrl: "getBILLINGDAILYSTATSExportUrl",
      getTablePermissions: "getBILLINGDAILYSTATSTablePermissions",
    },
    urls: {
      delete: `${process.env.VUE_APP_BASE_URL}/datahub/carrierMessages/destroy`,
      reset: `${process.env.VUE_APP_BASE_URL}/datahub/carrierMessages/reset`,
      reprocess: `${process.env.VUE_APP_BASE_URL}/datahub/carrierMessages/reprocess`,
    },
  }),
  methods: {
    async initTableContent() {
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_STRUCTURE, {});
      await this.$store.dispatch(this.table_state.UPDATE_TABLE_DATA, {});
    },
    regenerate() {
      this.$refs.regenerate.toggleModal();
    },
  },
  computed: {
    isDataLoaded: function () {
      return this.$store.getters[this.store_names.getTableData];
    },
  },
  beforeMount() {
    this.$store.commit(SET_PAGE_LOADING, true);
    this.initTableContent();
  },
};
</script>
